
import { defineComponent, reactive, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import RegisterFlow from '@/components/registerTeam/RegisterFlow.vue'
import useValidateForAccess from '@/Hooks/useValidateForAccess'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'SendMailCompletelyPage',
  setup() {
    const state = reactive({
      isEnabledResend: true,
      isVisibleConfirm: false,
      dialogSetting: {
        title: '',
        message: '',
      },
    })
    const router = useRouter()
    const { t, locale } = useI18n()
    onMounted(() => {
      useValidateForAccess(
        'RegisterTeamStore',
        ['teamName', 'organizationType', 'mailAddress'],
        'ErrorPage',
      )
    })
    return {
      state,
      t,
      locale,
      /**
       * メールアドレス確認・修正ボタン押下時
       */
      onClickConfirmationCorrection() {
        router.replace({ name: 'AuthenticateUserPage' })
      },
    }
  },
  components: {
    RegisterFlow,
  },
})
